<template>
  <div class="order-bundle">
    <v-app-bar
      app
      color="primary"
      dense
      :class="[{ '' /**desktop-mode-padding */: $vuetify.breakpoint.mdAndUp }, 'header', 'primaryText--text']"
    >
      <v-row>
        <v-col cols="2" style="display: flex">
          <v-app-bar-nav-icon @click="navBack" v-if="newOrder">
            <v-icon>mdi-arrow-left</v-icon>
          </v-app-bar-nav-icon>
        </v-col>

        <v-col cols="8" class="d-flex justify-center">
          <div>
            <v-toolbar-title
              class="header-title1"
              v-if="$store.state.store != null && $store.state.store.info != null"
              >{{ $store.getters.storeName }}</v-toolbar-title
            >
            <v-toolbar-title class="header-title2"
              >{{ $t($store.getters.orderFrom) }}
              <span class="header-title2-feature">{{ $t("order") }}</span></v-toolbar-title
            >
          </div>
        </v-col>

        <v-col cols="2" align-self="end" style="text-align: right">
          <v-app-bar-nav-icon v-if="!newOrder" @click="placeOrder">
            <v-icon>mdi-check</v-icon>
          </v-app-bar-nav-icon>
        </v-col>
      </v-row>
    </v-app-bar>

    <v-container v-if="$store.state.store != null" class="mt-n3">
      <v-row v-for="(bi, biIndex) in biList" :key="biIndex" @click="editOrderItem(bi)">
        <v-col
          cols="12"
          :class="[{ /*'bundle-item-error'*/ '': bi.bundleError !== undefined && bi.bundleError }, 'bundle-item']"
        >
          <v-row>
            <v-col cols="1">
              <div v-if="!(!bi.bItem && orderItem.promo != null)">
                <v-icon v-if="bi.accepted" class="bundle-item-check">mdi-check</v-icon>
                <v-icon v-else class="bundle-item-warn">mdi-alert-circle</v-icon>
              </div>
            </v-col>
            <v-col cols="7">
              <div class="item-descr">
                <span v-if="bi.orderItem.qty != 1 && bi.bItem">{{ bi.orderItem.qty }} x </span>
                <span v-if="$store.state.descrIndex == 1">{{ bi.orderItem.ord_descr1 }}</span>
                <span v-else-if="$store.state.descrIndex == 2">{{ bi.orderItem.ord_descr2 }}</span>
                <span v-else>{{ bi.orderItem.ord_descr }}</span>
              </div>

              <div v-if="$store.state.showItemBarcode && bi.orderItem.barcode != ''" class="item-barcode">
                {{ bi.orderItem.barcode }}
              </div>
              <div v-if="bi.orderItem.remark != ''" class="item-remark">{{ bi.orderItem.remark }}</div>
            </v-col>

            <v-col cols="3" v-if="!bi.bItem">
              <div v-if="orderItem.promo == null" class="text-right item-price">
                {{ (bi.orderItem.price + bi.orderItem.optionValue) | currency }}
              </div>
            </v-col>
            <v-col cols="3" v-else>
              <div v-if="orderItem.promo != null" class="text-right item-price">
                {{ getOrderItemTotal(bi.orderItem) | currency }}
              </div>
              <div v-else-if="bi.bundleItemPrice != 0" class="text-right item-price">
                {{ bi.bundleItemPrice | currency }}
              </div>
            </v-col>

            <v-col cols="1" class="text-right">
              <div v-if="bi.orderItem.options.length > 0" class="bundle-item-detail">
                <v-icon>mdi-chevron-right</v-icon>
              </div>
            </v-col>
          </v-row>

          <v-row v-if="getOrderItemDiscountTotal(bi.orderItem) > 0">
            <v-col cols="1"> </v-col>
            <v-col cols="7">
              <span v-if="bi.orderItem.itemDiscountRate > 0">{{ bi.orderItem.itemDiscountRate }}% </span
              >{{ $t("discount") }}
            </v-col>
            <v-col cols="3">
              <div class="text-right item-price">{{ -getOrderItemDiscountTotal(bi.orderItem) | currency }}</div>
            </v-col>
            <v-col cols="1" class="text-right"> </v-col>
          </v-row>

          <v-row v-if="bi.replaceWithNewItem && bi.replaced !== undefined && bi.replaced">
            <v-col cols="1" />
            <v-col cols="7">
              <v-chip
                smaill
                color="secondary"
                text-color="secondaryText"
                class="item-replace"
                @click="replaceBundleItem(bi)"
              >
                {{ $t("replace_bundle_item") }}
              </v-chip>
            </v-col>
          </v-row>
        </v-col>
      </v-row>

      <div v-if="$store.state.descrIndex == 0 && orderItem.item !== undefined && orderItem.item.detail != ''">
        <v-row>
          <v-col>
            {{ orderItem.item.detail }}
          </v-col>
        </v-row>
      </div>
      <div v-else-if="$store.state.descrIndex == 1 && orderItem.item !== undefined && orderItem.item.detail1 != ''">
        <v-row>
          <v-col>
            {{ orderItem.item.detail1 }}
          </v-col>
        </v-row>
      </div>
      <div v-else-if="$store.state.descrIndex == 2 && orderItem.item !== undefined && orderItem.item.detail2 != ''">
        <v-row>
          <v-col>
            {{ orderItem.item.detail2 }}
          </v-col>
        </v-row>
      </div>
    </v-container>

    <v-footer
      fixed
      v-show="!$store.getters.storeMenuMode"
      :class="{ '' /**'desktop-mode-padding-right'*/ /**desktop-mode-padding */: $vuetify.breakpoint.mdAndUp }"
    >
      <v-row align="center">
        <v-col v-show="orderItem.promo == null" :class="[{ 'pl-6': $vuetify.breakpoint.mdAndUp }]">
          {{ $t("quantity") }}</v-col
        >
        <v-col v-show="orderItem.promo == null" class="text-center">
          <v-icon class="order-qty-button" :disabled="orderItem.cbRefID > 0" @click="updateOrderQty(1)">
            mdi-plus
          </v-icon>
          <span class="order-qty">{{ orderItem.qty }}</span>
          <v-icon class="order-qty-button" :disabled="orderItem.cbRefID > 0" @click="updateOrderQty(-1)">
            mdi-minus
          </v-icon>
        </v-col>
        <v-col :class="[{ 'pr-6': $vuetify.breakpoint.mdAndUp }, 'text-right']">
          <v-btn color="info" class="order-button infoText--text" v-if="newOrder" @click="placeOrder">{{
            $t("placeorder")
          }}</v-btn>
        </v-col>
      </v-row>
    </v-footer>

    <v-overlay :value="refreshing">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
  </div>
</template>

<script>
export default {
  data() {
    return {
      refreshing: false,

      orderItem: {},
      biList: [],

      newOrder: true,
      replacingBundleItem: false,

      validOrder: false,
    };
  },

  beforeRouteLeave(to, from, next) {
    /*     if (to.name == "Checkout" || to.name == "MenuFull" || to.name == "MenuCategory" || to.name == "MenuItem") {
      this.calculateTotal();
      this.setOrderToStorage();
    }

    this.biList.forEach(bi => {
      if (bi.bundleError !== undefined) {
        bi.bundleError = false;
      }
    }); */

    next(this.newOrder || this.validOrder || to.name == "Order" || to.name == "MenuItem");
  },

  activated() {
    this.validOrder = false;

    if (
      this.$store.state.routeFrom.name == "MenuFull" ||
      this.$store.state.routeFrom.name == "MenuCategory" ||
      this.$store.state.routeFrom.name == "MenuItem" ||
      this.$store.state.routeFrom.name == "Checkout" ||
      this.$store.state.routeFrom.name == "Offer"
    ) {
      if (this.$route.params.item !== undefined) {
        let item = this.$route.params.item;
        this.orderItem = this.itemToOrderItem(item);
        this.newOrder = true;
      } else if (this.$route.params.orderItem !== undefined) {
        this.orderItem = this.$route.params.orderItem;
        this.newOrder = false;
      }

      let n_bi = {
        bItem: false,
        applyDiff: "",
        itemPrice: this.orderItem.price,
        catIDs: null,
        replaceWithNewItem: false,
        orderItem: this.orderItem,
        accepted: false,
        bundleItemPrice: 0,
      };
      this.biList = [];
      this.biList.push(n_bi);
      if (this.orderItem.bundleItems != null) {
        this.orderItem.bundleItems.forEach(bi => {
          this.biList.push(bi);
        });
      }
    }

    this.replacingBundleItem = false;
    let biAdjHighest = null;
    let n_badj = 0;
    for (let bi of this.biList) {
      let boi = bi.orderItem;
      let priceDiff = 0;
      if (this.orderItem.promo == null) priceDiff = this.getOrderItemExtended(boi) - boi.qty * bi.itemPrice;
      else priceDiff = this.getOrderItemExtended(boi);
      if (
        bi.applyDiff == "all" ||
        (priceDiff > 0 && bi.applyDiff == "higher") ||
        (priceDiff < 0 && bi.applyDiff == "lower")
      ) {
        bi.bundleItemPrice = priceDiff;
        n_badj += bi.bundleItemPrice;
      } else if (bi.applyDiff == "highest") {
        if (biAdjHighest == null) {
          biAdjHighest = bi;
          bi.bundleItemPrice = priceDiff;
        } else if (biAdjHighest.bundleItemPrice < priceDiff) {
          biAdjHighest.bundleItemPrice = 0;
          biAdjHighest = bi;
          bi.bundleItemPrice = priceDiff;
        }
      }

      bi.accepted = this.bundleItemAccepted(bi);
    }
    if (biAdjHighest != null) {
      n_badj += biAdjHighest.bundleItemPrice;
    }

    this.orderItem.bAdj = n_badj;

    console.log(this.orderItem, this.biList);
  },

  computed: {},

  methods: {
    updateOrderQty(qty) {
      this.orderItem.qty = this.orderItem.qty + qty;
      if (this.orderItem.qty < 1) this.orderItem.qty = 1;
    },

    bundleItemAccepted(bi) {
      let accepted = true;
      let optCount = 0;

      let oi = bi.orderItem;
      for (let og of oi.options) {
        optCount += og.qty;
        if (og.min > 0 && og.qty < og.min) {
          accepted = false;
          break;
        }
      }

      if (accepted) {
        if (
          (oi.replaceDescrWithOption && optCount == 0) ||
          (bi.replaceWithNewItem && (bi.replaced === undefined || !bi.replaced))
        ) {
          accepted = false;
        }
      }

      return accepted;
    },

    editOrderItem(bi) {
      if (this.replacingBundleItem) return;
      //if (bi.replaceWithNewItem && (bi.catIDs == null || bi.catIDs.length == 0)) return;

      if (bi.bItem) {
        if (bi.replaceWithNewItem && (bi.replaced === undefined || !bi.replaced)) {
          this.replaceBundleItem(bi);
        } else {
          let params = { bundleItem: bi };
          this.navName("Order", params);
        }
      } else {
        let params = { bundleItem: bi };
        this.navName("Order", params);
      }
    },

    replaceBundleItem(bi) {
      if (
        (bi.catIDs == null || bi.catIDs.length == 0) &&
        (bi.catCodes == null || bi.catCodes.length == 0) &&
        (bi.itemCodes == null || bi.itemCodes.length == 0)
      )
        return;
      this.replacingBundleItem = true;

      let that = this;
      let getNewBundleItem = function(item) {
        return new Promise(resolve => {
          resolve();

          let cloneItem = that.cloneObject(item);
          cloneItem.itemDiscountRate = bi.itemDiscountRate;
          cloneItem.bItem = true;
          cloneItem.bItems = [];
          bi.item = cloneItem;

          //console.log("getNewBundleItem", bi);

          setTimeout(function() {
            if (!that.$store.state.itemFastAdd || bi.item.options.length > 0) {
              let params = { bundleItem: bi };
              that.navName("Order", params);
            } else {
              bi.orderItem = that.itemToOrderItem(bi.item);
              bi.orderItem.qty = bi.qty;
              bi.replaced = true;
            }
          }, 100);
        });
      };

      this.navName("MenuItem", {
        key: this.orderItem.ID,
        catIDs: bi.catIDs,
        catCodes: bi.catCodes,
        itemCodes: bi.itemCodes,
        getNewBundleItem: getNewBundleItem,
      });
    },

    placeOrder() {
      if (this.newOrder && !this.$store.getters.acceptOrder) {
        this.$root.messageDialog(this.$t("not_acception_order"), "", this.$t("not_acception_order_message"));
        return;
      }

      let invalid_bi;
      for (let bi of this.biList) {
        if (!bi.accepted) {
          invalid_bi = bi;
          break;
        }
      }

      if (invalid_bi == null) {
        if (this.newOrder) this.addOrderItem(this.orderItem);
        else {
          this.calculateTotal();
          this.setOrderToStorage();
        }

        this.validOrder = true;
        if (this.$appMode == 1 /* && this.newOrder*/) {
          if (this.$store.getters.categoryPosition == "center") this.navName("MenuCategory");
          else this.navName("MenuFull");
        } else this.navBack();
      } else {
        invalid_bi.bundleError = true;
        this.$root.messageDialog(this.$t("error_alert_title"), "", this.$t("error_bundle_selections_not_complete"));
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/sass/variables.scss";

.bundle-item {
  border-bottom-color: rgb(200, 200, 200);
  border-bottom-style: solid;
  border-bottom-width: 1px;
  > .row {
    padding: 12px;
  }
  .col {
    padding: 0px;
  }

  .bundle-item-check {
    color: green;
  }

  .bundle-item-warn {
    color: var(--v-warning-base);
  }

  .item-barcode {
    font-size: 0.8em;
    font-weight: bold;
    color: var(--v-accent-base);
  }
}

.bundle-item-error {
  background-color: var(--v-warning-lighten1);
  color: var(--v-warningText-base);
}

.v-footer {
  padding-bottom: calc(6px + env(safe-area-inset-bottom));

  .col {
    padding: 0px;
  }

  .order-qty {
    font-size: 1.5em;
    padding: 0px 12px;
    vertical-align: sub;
  }

  .order-qty-button {
    font-size: 1.5em;
  }

  .order-button {
    color: black !important;
    padding: 0px 8px !important;
    font-size: 0.9em;
  }
}
</style>
